/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import React from 'react';
import { Box, Button, Flex } from '@radix-ui/themes';
import { RefreshCw } from 'lucide-react';

import type { FilterSection } from '../../../../shared/FilterSidebar';
import { QuarantineFilterGroup } from './QuarantineFilterGroup';
import { QUARANTINE_STRINGS as STRINGS } from './quarantine.strings';

export interface QuarantineFiltersProps {
  sections: FilterSection[];
  onFilterChange: (sectionId: string, values: string[]) => void;
  onReset: () => void;
  disabled?: boolean;
}

/** Quarantine filter rail: reset button, then one checkbox group per facet. */
export function QuarantineFilters({
  sections,
  onFilterChange,
  onReset,
  disabled = false,
}: QuarantineFiltersProps): JSX.Element {
  const active = sections.some((section) => Array.isArray(section.value) && section.value.length > 0);

  return (
    <Box>
      <Flex align="center" justify="start" mb="4" className="quarantine-filters__header">
        <Button
          variant="outline"
          color="gray"
          size="2"
          onClick={onReset}
          disabled={disabled || !active}
          data-analytics-id="nxrm-security-quarantine-filter-reset-btn"
        >
          <RefreshCw size={12} aria-hidden="true" />
          {STRINGS.filters.reset}
        </Button>
      </Flex>
      <Flex direction="column" gap="4">
        {sections.map((section) => (
          <QuarantineFilterGroup
            key={section.id}
            section={section}
            onChange={(values) => onFilterChange(section.id, values)}
            disabled={disabled}
          />
        ))}
      </Flex>
    </Box>
  );
}
